import { render, staticRenderFns } from "./ChoiceListEditor.vue?vue&type=template&id=0410d26a"
import script from "./ChoiceListEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoiceListEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChoiceListEditor.vue?vue&type=style&index=0&id=0410d26a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports